module.exports = import("https://barra.sistema.gov.br/v1/barra-govbr-wc.js");;